import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const MenuBurgerIcon = createIcon({
  displayName: 'MenuBurgerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <line x1="5.5" x2="18.5" y1="12" y2="12" />
        <line x1="5.5" x2="18.5" y1="16" y2="16" />
        <line x1="5.5" x2="18.5" y1="8" y2="8" />
      </g>
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const MenuBurger: FC<IconProps> = (props) => {
  return <CustomIcon as={MenuBurgerIcon} {...props} />
}

export default memo(MenuBurger)
